/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/AzureRMEndpointConstants" />

export const enum Environment {
    AZURE_CLOUD = "AzureCloud",
    AZURE_CHINA_CLOUD = "AzureChinaCloud",
    AZURE_US_GOVERNMENT = "AzureUSGovernment",
    AZURE_GERMAN_CLOUD = "AzureGermanCloud",
    AZURE_STACK = "AzureStack"
}

export const enum AzureRMKeys {
    ACTION_CREATOR_KEY = "azure-rm-actioncreator",
    ACTIONS_KEY = "azure-rm-actions",
    STORE_KEY = "azure-rm-store",
    AZURERM_INSTANCE_KEY = "azure-rm",
    PUBLISH_PROFILE_INSTANCE_KEY = "azure-rm-publish-profile"
}